var core = require('../../core'),
    blurFactor = 1 / 7000;


/**
 * The BlurYTintFilter applies a vertical Gaussian blur to an object.
 *
 * @class
 * @extends AbstractFilter
 * @memberof PIXI.filters
 */
function BlurYTintFilter()
{
    core.AbstractFilter.call(this,
        // vertex shader
        "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\n\nuniform float strength;\nuniform vec2 offset;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying vec2 vBlurTexCoords[14];\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3((aVertexPosition+offset), 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n\n    vBlurTexCoords[ 0] = aTextureCoord + vec2(0.0, -0.028 * strength);\n    vBlurTexCoords[ 1] = aTextureCoord + vec2(0.0, -0.024 * strength);\n    vBlurTexCoords[ 2] = aTextureCoord + vec2(0.0, -0.020 * strength);\n    vBlurTexCoords[ 3] = aTextureCoord + vec2(0.0, -0.016 * strength);\n    vBlurTexCoords[ 4] = aTextureCoord + vec2(0.0, -0.012 * strength);\n    vBlurTexCoords[ 5] = aTextureCoord + vec2(0.0, -0.008 * strength);\n    vBlurTexCoords[ 6] = aTextureCoord + vec2(0.0, -0.004 * strength);\n    vBlurTexCoords[ 7] = aTextureCoord + vec2(0.0,  0.004 * strength);\n    vBlurTexCoords[ 8] = aTextureCoord + vec2(0.0,  0.008 * strength);\n    vBlurTexCoords[ 9] = aTextureCoord + vec2(0.0,  0.012 * strength);\n    vBlurTexCoords[10] = aTextureCoord + vec2(0.0,  0.016 * strength);\n    vBlurTexCoords[11] = aTextureCoord + vec2(0.0,  0.020 * strength);\n    vBlurTexCoords[12] = aTextureCoord + vec2(0.0,  0.024 * strength);\n    vBlurTexCoords[13] = aTextureCoord + vec2(0.0,  0.028 * strength);\n\n   vColor = vec4(aColor.rgb * aColor.a, aColor.a);\n}\n",
        // fragment shader
        "precision lowp float;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vBlurTexCoords[14];\nvarying vec4 vColor;\n\nuniform float blur;\nuniform vec3 color;\nuniform float alpha;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    vec4 sum = vec4(0.0);\n\n    sum += texture2D(uSampler, vBlurTexCoords[ 0])*0.0044299121055113265;\n    sum += texture2D(uSampler, vBlurTexCoords[ 1])*0.00895781211794;\n    sum += texture2D(uSampler, vBlurTexCoords[ 2])*0.0215963866053;\n    sum += texture2D(uSampler, vBlurTexCoords[ 3])*0.0443683338718;\n    sum += texture2D(uSampler, vBlurTexCoords[ 4])*0.0776744219933;\n    sum += texture2D(uSampler, vBlurTexCoords[ 5])*0.115876621105;\n    sum += texture2D(uSampler, vBlurTexCoords[ 6])*0.147308056121;\n    sum += texture2D(uSampler, vTextureCoord         )*0.159576912161;\n    sum += texture2D(uSampler, vBlurTexCoords[ 7])*0.147308056121;\n    sum += texture2D(uSampler, vBlurTexCoords[ 8])*0.115876621105;\n    sum += texture2D(uSampler, vBlurTexCoords[ 9])*0.0776744219933;\n    sum += texture2D(uSampler, vBlurTexCoords[10])*0.0443683338718;\n    sum += texture2D(uSampler, vBlurTexCoords[11])*0.0215963866053;\n    sum += texture2D(uSampler, vBlurTexCoords[12])*0.00895781211794;\n    sum += texture2D(uSampler, vBlurTexCoords[13])*0.0044299121055113265;\n\n    gl_FragColor = vec4( color.rgb * sum.a * alpha, sum.a * alpha );\n}\n",
        // set the uniforms
        {
            blur: { type: '1f', value: 1 / 512 },
            color: { type: 'c', value: [0,0,0]},
            alpha: { type: '1f', value: 0.7 },
            offset: { type: '2f', value:[5, 5]}
        }
    );
}

BlurYTintFilter.prototype = Object.create(core.AbstractFilter.prototype);
BlurYTintFilter.prototype.constructor = BlurYTintFilter;
module.exports = BlurYTintFilter;

Object.defineProperties(BlurYTintFilter.prototype, {
    /**
     * Sets the strength of both the blur.
     *
     * @member {number}
     * @memberof BlurYTintFilter#
     * @default 2
     */
    blur: {
        get: function ()
        {
            return this.uniforms.blur.value / blurFactor;
        },
        set: function (value)
        {
            this.uniforms.blur.value = blurFactor * value;
        }
    }
});
